import { AlertCircle } from 'lucide-react'

interface EmptyStateProps {
    title?: string
}

export default function EmptyState({
    title = 'Đang cập nhật',
}: EmptyStateProps) {
    return (
        <div className="flex flex-col items-center justify-center mt-4 py-10 px-4 text-center bg-amber-50 rounded-lg border border-amber-200">
            <AlertCircle className="w-12 h-12 text-amber-600 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        </div>
    )
}
